module.exports = ".icon-success{font-size:48px;color:#8BC34A !important}.icon-error{font-size:48px;color:#E41736 !important}.error-message{color:#E41736}.success-message{color:#fff}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/change-password/change-password.component.scss
// module id = 710
// module chunks = 0